export const PriceTrendsLegend = ({ payload }) => {
    if (!payload) return null;

    const sorted = [...payload].sort((a, b) => {
        if (a.value === "Your Hotel") return -1;
        if (b.value === "Your Hotel") return 1;
        return 0;
    });

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "12px",
                paddingTop: "10px",
            }}
        >
            {sorted.map((entry) => (
                <div
                    key={entry.value}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        marginRight: 10,
                    }}
                >
                    <span
                        style={{
                            width: 14,
                            height: 14,
                            backgroundColor: entry.color,
                            display: "inline-block",
                            marginRight: 6,
                            borderRadius: 2,
                        }}
                    />
                    <span
                        style={{
                            fontSize: 14,
                            fontWeight: entry.value === "Your Hotel" ? 600 : 400,
                        }}
                    >
                        {entry.value}
                    </span>
                </div>
            ))}
        </div>
    );
};


import { COLORS } from '@/constants';
import React from 'react';

function CustomLegend({ filteredCompetitors }) {
    return (
        <div className="mt-3 pt-3 border-t flex flex-wrap gap-4 text-sm justify-center">
            <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: 'hsl(var(--primary))' }} />
                <span className="font-medium">Your Hotel</span>
            </div>
            {filteredCompetitors
                ?.map((comp, idx) => {
                    const key = comp?.name;
                    return (
                        <div key={idx} className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[idx + 1] }} />
                            <span className="font-medium">{key}</span>
                            {/* <span className="text-muted-foreground">(Avg: {avg.toFixed(1)})</span> */}
                        </div>
                    );
                })}
        </div>
    );
}

export default CustomLegend;

